import * as React from 'react';
import Button from '../_common/button';
import Modal from '../_common/modal';
import { cn, getText } from '../../helpers';
import keyPages from '../../utilities/key-pages';
import RequestTrialFormProvider from '../_providers/rat-form-provider/rat-form-provider';

const defaultVariantDataset = {
    buttonText: getText('generic.requestThisVisualization'),
    buttonTitle: getText('generic.requestThisVisualization')
};
const buttonVariants: RequestThisVisualizationButtonText = {
    default: defaultVariantDataset
};


function getKeyPageId(productVariant: string): keyPages {
    if (productVariant === 'solution') {
        return keyPages.solutionRATForm;
    }
    return keyPages.datasetRATForm;
}


function RequestThisVisualizationButton(props: RequestThisVisualizationButtonProps) {
    const [modalIsOpen, setModalOpen] = React.useState<boolean>(false);
    const { productVariant, className, productName = '', dataProvider, buttonText, metaData } = props;
    const customText = buttonVariants.default;

    return (
        <div className="page-section">
            <div className="page-section__inner">
                <Button
                    text={buttonText || customText.buttonText}
                    onClick={() => setModalOpen(true)}
                    theme="primary"
                    gtmId="viz-form-load"
                    className={cn('rta-btn-viz', className)}
                />
                <Modal
                    open={modalIsOpen}
                    onClose={() => setModalOpen(false)}
                    isFullScreen={window.innerWidth < 1024}
                    scrollBody
                    keyPageId={getKeyPageId(productVariant)}
                    maxWidth="md"
                    title="request this visualization"
                >
                    <RequestTrialFormProvider
                        dataProvider={dataProvider}
                        productVariant={productVariant}
                        productName={productName}
                        // productId={productId}
                        titleText={buttonText}
                        metaData={metaData}
                    />
                </Modal>
            </div>
        </div>
    );
}

export default React.memo(RequestThisVisualizationButton);
